import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import ConfigCard from './ConfigCard';

/**
 * "Newsletter signup" card. The popup-related options collapse when the
 * top-level "Show signup in a popup" toggle is off.
 *
 * value shape:
 *   { enabled, showInPopup, openPopupAutomatically }
 */
const NewsletterSignupCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb = false) => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (v) => onChange && onChange(k, v);

    const showInPopup = get('showInPopup');

    return (
        <ConfigCard
            title={tr('cfg_footer_newsletter_title', 'Newsletter signup')}
            description={tr('cfg_footer_newsletter_desc', 'Let visitors subscribe to your newsletter from the shop.')}
            theme={theme}
        >
            <FormControlLabel
                control={
                    <Switch color="success"
                        size="small"
                        checked={!!get('enabled')}
                        onChange={(e) => set('enabled')(e.target.checked)}
                    />
                }
                label={<Typography variant="body2">{tr('cfg_footer_newsletter_enable', 'Enable newsletter signup')}</Typography>}
            />
            <Box sx={{ pl: 4, opacity: get('enabled') ? 1 : 0.5, pointerEvents: get('enabled') ? 'auto' : 'none' }}>
                <Stack spacing={0.5}>
                    <FormControlLabel
                        control={
                            <Switch color="success"
                                size="small"
                                checked={!!showInPopup}
                                onChange={(e) => set('showInPopup')(e.target.checked)}
                            />
                        }
                        label={<Typography variant="body2">{tr('cfg_footer_newsletter_popup', 'Show signup in a popup')}</Typography>}
                    />
                    {showInPopup && (
                        <Box sx={{ pl: 4 }}>
                            <FormControlLabel
                                control={
                                    <Switch color="success"
                                        size="small"
                                        checked={!!get('openPopupAutomatically')}
                                        onChange={(e) => set('openPopupAutomatically')(e.target.checked)}
                                    />
                                }
                                label={<Typography variant="body2">{tr('cfg_footer_newsletter_popup_auto', 'Open popup automatically for first-time visitors')}</Typography>}
                            />
                        </Box>
                    )}
                </Stack>
            </Box>
        </ConfigCard>
    );
};

NewsletterSignupCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default NewsletterSignupCard;
